import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateComment, selectActiveEntityId } from '../../redux/notesetting/notesSettingsSlice';
import { formatRelativeTime } from '../../utility/helpers';
import { FiMoreHorizontal } from 'react-icons/fi';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import ExternalNoteForm from './ExternalNoteForm';

const ExternalComment = ({ commentDetails, alreadyExists, workflowContactId}) => {
  const dispatch = useDispatch();

  const [editableCommentId, setEditableCommentId] = useState(null);
  const activeNoteId = useSelector(selectActiveEntityId);

  // const handleSubmit = (commentId, newText) => {
  //   dispatch(updateComment({ id: commentId, text: newText }));
  //   setEditableCommentId(null);
  // };
  const existingComments = useMemo(() => {
    if (!alreadyExists?.length) return null;

    // Filter blocks based on activeNoteId match
    const filteredBlocks = alreadyExists.filter((block) => block.commentBlockId === activeNoteId);

    return filteredBlocks.map((block) => (
      <span key={`block-${block.commentBlockId}`} className="comment-block">
        {block.comments?.map((comment) => (
          <div className="comment">
            <div className="comment-header">
              <img src={require('../../static/img/No_image_available.png')} alt="" />
              <span key={`comment-${comment.commentId}`} className="comment-exists-block">
                <strong className="comment-exists">{comment.createdBy}</strong>
                <span className="date">{formatRelativeTime(comment.createdDateTime)}</span>
              </span>
              <>
                <DropdownMenu.Root>
                  <div className="edit-button-container" hidden={comment.proofWorkflowContactId !== workflowContactId}>
                    <DropdownMenu.Trigger className="edit-button note-icons-btn">
                      <FiMoreHorizontal />
                    </DropdownMenu.Trigger>
                  </div>
                  <DropdownMenu.Portal>
                    <DropdownMenu.Content className="edit-content" sideOffset={7}>
                      <DropdownMenu.Item
                        className="drop-down-item"
                        onClick={() => setEditableCommentId(comment.commentId)}
                      >
                        Edit...
                      </DropdownMenu.Item>
                    </DropdownMenu.Content>
                  </DropdownMenu.Portal>
                </DropdownMenu.Root>
              </>
            </div>
            {editableCommentId === comment.commentId ? (
              <ExternalNoteForm
                defaultInputValue={comment.description}
                // onSubmit={(newText) => handleSubmit(comment.commentId, newText)}
                onCancel={() => setEditableCommentId(null)}
                commentId={comment.commentId}
                commentBlockId={block.commentBlockId}
              />
            ) : (
              <>
                <p className="comment-description comment-content">{comment.description}</p>
              </>
            )}
          </div>
        ))}
      </span>
    ));
  }, [alreadyExists, editableCommentId, activeNoteId]);

  return <span> {existingComments}</span>;
};

export default ExternalComment;
